var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83398 28.3332V5.6665H31.1673V28.3332H2.83398ZM17.0007 18.4165L28.334 11.3332V8.49984L17.0007 15.5832L5.66732 8.49984V11.3332L17.0007 18.4165Z",
    fill: "#FBF8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/contact-email.e093b184e100925ae1dfe04e9d96f6c7.svg";
export { ForwardRef as ReactComponent };